import { ActivityLogOperationTypeEnum } from '../enums/ActivityLogOperationTypeEnum';
import { ActivityLogTargetTypeEnum } from '../enums/ActivityLogTargetTypeEnum';
import type ActivityLogGroupedType from '../interfaces/ActivityLogGroupedType';

export const activityLogGroupedTargetOperationTypes: ActivityLogGroupedType[] = [
  {
    title: 'activityLogTargetTypes.File',
    value: ActivityLogTargetTypeEnum.File.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.CreateFile',
        value: ActivityLogOperationTypeEnum.CreateFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.ReadFile',
        value: ActivityLogOperationTypeEnum.ReadFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.DownloadFile',
        value: ActivityLogOperationTypeEnum.DownloadFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.DownloadFileEncrypted',
        value: ActivityLogOperationTypeEnum.DownloadFileEncrypted.toString(),
      },
      {
        title: 'activityLogOperationTypes.DownloadFileZip',
        value: ActivityLogOperationTypeEnum.DownloadFileZip.toString(),
      },
      {
        title: 'activityLogOperationTypes.RenameFile',
        value: ActivityLogOperationTypeEnum.RenameFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.MoveFile',
        value: ActivityLogOperationTypeEnum.MoveFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.DuplicateFile',
        value: ActivityLogOperationTypeEnum.DuplicateFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.UploadFile',
        value: ActivityLogOperationTypeEnum.UploadFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.DeleteFileToRecycleBin',
        value: ActivityLogOperationTypeEnum.DeleteFileToRecycleBin.toString(),
      },
      {
        title: 'activityLogOperationTypes.DeleteFilePermanently',
        value: ActivityLogOperationTypeEnum.DeleteFilePermanently.toString(),
      },
      {
        title: 'activityLogOperationTypes.ShareFile',
        value: ActivityLogOperationTypeEnum.ShareFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.PreviewFile',
        value: ActivityLogOperationTypeEnum.PreviewFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.HiddenFile',
        value: ActivityLogOperationTypeEnum.HiddenFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.UnhiddenFile',
        value: ActivityLogOperationTypeEnum.UnhiddenFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.AddToFavorites',
        value: ActivityLogOperationTypeEnum.AddToFavorites.toString(),
      },
      {
        title: 'activityLogOperationTypes.RemoveFromFavorites',
        value: ActivityLogOperationTypeEnum.RemoveFromFavorites.toString(),
      },

      {
        title: 'activityLogOperationTypes.RestoreFile',
        value: ActivityLogOperationTypeEnum.RestoreFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.TagFile',
        value: ActivityLogOperationTypeEnum.TagFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.RemoveTagFile',
        value: ActivityLogOperationTypeEnum.RemoveTagFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.EncryptFile',
        value: ActivityLogOperationTypeEnum.EncryptFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.DecryptFile',
        value: ActivityLogOperationTypeEnum.DecryptFile.toString(),
      },
      {
        title: 'activityLogOperationTypes.ChangeFileOwner',
        value: ActivityLogOperationTypeEnum.ChangeFileOwner.toString(),
      },
      {
        title: 'activityLogOperationTypes.SetFileExpiration',
        value: ActivityLogOperationTypeEnum.SetFileExpiration.toString(),
      },
      {
        title: 'activityLogOperationTypes.GenerateShareLink',
        value: ActivityLogOperationTypeEnum.GenerateShareLink.toString(),
      },
      {
        title: 'activityLogOperationTypes.ShortCut',
        value: ActivityLogOperationTypeEnum.ShortCut.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.Folder',
    value: ActivityLogTargetTypeEnum.Folder.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.CreateFolder',
        value: ActivityLogOperationTypeEnum.CreateFolder.toString(),
      },
      {
        title: 'activityLogOperationTypes.ReadFolder',
        value: ActivityLogOperationTypeEnum.ReadFolder.toString(),
      },
      {
        title: 'activityLogOperationTypes.DeleteFolderToRecycleBin',
        value: ActivityLogOperationTypeEnum.DeleteFolderToRecycleBin.toString(),
      },
      {
        title: 'activityLogOperationTypes.DeleteFolderPermanently',
        value: ActivityLogOperationTypeEnum.DeleteFolderPermanently.toString(),
      },
      {
        title: 'activityLogOperationTypes.ShareFolder',
        value: ActivityLogOperationTypeEnum.ShareFolder.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.User',
    value: ActivityLogTargetTypeEnum.User.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.GrantAccess',
        value: ActivityLogOperationTypeEnum.GrantAccess.toString(),
      },
      {
        title: 'activityLogOperationTypes.CreateUser',
        value: ActivityLogOperationTypeEnum.CreateUser.toString(),
      },
      {
        title: 'activityLogOperationTypes.EditUser',
        value: ActivityLogOperationTypeEnum.EditUser.toString(),
      },
      {
        title: 'activityLogOperationTypes.RemoveUser',
        value: ActivityLogOperationTypeEnum.RemoveUser.toString(),
      },
      {
        title: 'activityLogOperationTypes.ValidateUser',
        value: ActivityLogOperationTypeEnum.ValidateUser.toString(),
      },
      {
        title: 'activityLogOperationTypes.LogIn',
        value: ActivityLogOperationTypeEnum.LogIn.toString(),
      },
      {
        title: 'activityLogOperationTypes.LogOut',
        value: ActivityLogOperationTypeEnum.LogOut.toString(),
      },
      {
        title: 'activityLogOperationTypes.OTPRequest',
        value: ActivityLogOperationTypeEnum.OTPRequest.toString(),
      },
      {
        title: 'activityLogOperationTypes.LastCheckToken',
        value: ActivityLogOperationTypeEnum.LastCheckToken.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncUserDisabled',
        value: ActivityLogOperationTypeEnum.DirectorySyncUserDisabled.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncUserEnabled',
        value: ActivityLogOperationTypeEnum.DirectorySyncUserEnabled.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncUserImported',
        value: ActivityLogOperationTypeEnum.DirectorySyncUserImported.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.Group',
    value: ActivityLogTargetTypeEnum.Group.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.CreateGroup',
        value: ActivityLogOperationTypeEnum.CreateGroup.toString(),
      },
      {
        title: 'activityLogOperationTypes.EditGroup',
        value: ActivityLogOperationTypeEnum.EditGroup.toString(),
      },
      {
        title: 'activityLogOperationTypes.RemoveGroup',
        value: ActivityLogOperationTypeEnum.RemoveGroup.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncGroupMembersChanged',
        value: ActivityLogOperationTypeEnum.DirectorySyncGroupMembersChanged.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncGroupImported',
        value: ActivityLogOperationTypeEnum.DirectorySyncGroupImported.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.Admin',
    value: ActivityLogTargetTypeEnum.Admin.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.DirectorySyncStarted',
        value: ActivityLogOperationTypeEnum.DirectorySyncStarted.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncCompleted',
        value: ActivityLogOperationTypeEnum.DirectorySyncCompleted.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncFailed',
        value: ActivityLogOperationTypeEnum.DirectorySyncFailed.toString(),
      },
      {
        title: 'activityLogOperationTypes.DirectorySyncConnectionTested',
        value: ActivityLogOperationTypeEnum.DirectorySyncConnectionTested.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.FilesFoldersAndTags',
    value: ActivityLogTargetTypeEnum.FilesFoldersAndTags.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.SearchFiles',
        value: ActivityLogOperationTypeEnum.SearchFiles.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.Tag',
    value: ActivityLogTargetTypeEnum.Tag.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.AddTag',
        value: ActivityLogOperationTypeEnum.AddTag.toString(),
      },
      {
        title: 'activityLogOperationTypes.RemoveTag',
        value: ActivityLogOperationTypeEnum.RemoveTag.toString(),
      },
      {
        title: 'activityLogOperationTypes.UpdateTag',
        value: ActivityLogOperationTypeEnum.UpdateTag.toString(),
      },
      {
        title: 'activityLogOperationTypes.ListTags',
        value: ActivityLogOperationTypeEnum.ListTags.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.Email',
    value: ActivityLogTargetTypeEnum.Email.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.EmailSent',
        value: ActivityLogOperationTypeEnum.EmailSent.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailRead',
        value: ActivityLogOperationTypeEnum.EmailRead.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailSaveDraft',
        value: ActivityLogOperationTypeEnum.EmailSaveDraft.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailUpdateDraft',
        value: ActivityLogOperationTypeEnum.EmailUpdateDraft.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailTrash',
        value: ActivityLogOperationTypeEnum.EmailTrash.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailRestore',
        value: ActivityLogOperationTypeEnum.EmailRestore.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailDelete',
        value: ActivityLogOperationTypeEnum.EmailDelete.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailArchive',
        value: ActivityLogOperationTypeEnum.EmailArchive.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailUnarchive',
        value: ActivityLogOperationTypeEnum.EmailUnarchive.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailFavourite',
        value: ActivityLogOperationTypeEnum.EmailFavourite.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailUnfavourite',
        value: ActivityLogOperationTypeEnum.EmailUnfavourite.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailAttachmentRemoved',
        value: ActivityLogOperationTypeEnum.EmailAttachmentRemoved.toString(),
      },
      {
        title: 'activityLogOperationTypes.EmailRecipientRemoved',
        value: ActivityLogOperationTypeEnum.EmailRecipientRemoved.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.AuditLog',
    value: ActivityLogTargetTypeEnum.AuditLog.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.ViewAuditLog',
        value: ActivityLogOperationTypeEnum.ViewAuditLog.toString(),
      },
      {
        title: 'activityLogOperationTypes.ExportAuditLog',
        value: ActivityLogOperationTypeEnum.ExportAuditLog.toString(),
      },
      {
        title: 'activityLogOperationTypes.ViewAuditLogFailed',
        value: ActivityLogOperationTypeEnum.ViewAuditLogFailed.toString(),
      },
      {
        title: 'activityLogOperationTypes.ExportAuditLogFailed',
        value: ActivityLogOperationTypeEnum.ExportAuditLogFailed.toString(),
      },
      {
        title: 'activityLogOperationTypes.PurgeAuditLog',
        value: ActivityLogOperationTypeEnum.PurgeAuditLog.toString(),
      },
    ],
  },
  {
    title: 'activityLogTargetTypes.SharePointFile',
    value: ActivityLogTargetTypeEnum.SharePointFile.toString(),
    children: [
      {
        title: 'activityLogOperationTypes.SharePointFileEncrypted',
        value: ActivityLogOperationTypeEnum.SharePointFileEncrypted.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointFileEncryptionFailed',
        value: ActivityLogOperationTypeEnum.SharePointFileEncryptionFailed.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointFileEncryptionSkipped',
        value: ActivityLogOperationTypeEnum.SharePointFileEncryptionSkipped.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointScanCycleCompleted',
        value: ActivityLogOperationTypeEnum.SharePointScanCycleCompleted.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointScanCycleFailed',
        value: ActivityLogOperationTypeEnum.SharePointScanCycleFailed.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointConnectionTested',
        value: ActivityLogOperationTypeEnum.SharePointConnectionTested.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointConnectionTestFailed',
        value: ActivityLogOperationTypeEnum.SharePointConnectionTestFailed.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointPerimeterBrowsed',
        value: ActivityLogOperationTypeEnum.SharePointPerimeterBrowsed.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointViewerTokenIssued',
        value: ActivityLogOperationTypeEnum.SharePointViewerTokenIssued.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointViewerTokenDenied',
        value: ActivityLogOperationTypeEnum.SharePointViewerTokenDenied.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointEditSessionOpened',
        value: ActivityLogOperationTypeEnum.SharePointEditSessionOpened.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointEditSessionDenied',
        value: ActivityLogOperationTypeEnum.SharePointEditSessionDenied.toString(),
      },
      {
        title: 'activityLogOperationTypes.SharePointFileEdited',
        value: ActivityLogOperationTypeEnum.SharePointFileEdited.toString(),
      },
    ],
  },
];
